import { createSlice } from "@reduxjs/toolkit";

/**
 * The subscriptions tab of one customer's profile. Its own slice rather than sharing
 * customerSubscription: that one belongs to the whole Customer Subscriptions screen, and a
 * page or a search term set on this tab has no business surviving into it.
 */
const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  sortBy: "",
  sortOrder: "desc",
  search: "",

  showDetailsModal: false,
  showCreditModal: false,
  showCancelModal: false,
  selectedId: "",
  // The whole row, not just its id: the credit and cancel dialogs name the plan and show
  // what is left on it, and neither wants to fetch a subscription the table already holds.
  selectedSubscription: {},
};

const userSubscriptionSlice = createSlice({
  name: "userSubscription",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = userSubscriptionSlice.actions;
export default userSubscriptionSlice.reducer;
